// extracted by mini-css-extract-plugin
export default {"container":"modalReconexion_container__611Jc","buttonContainer":"modalReconexion_buttonContainer__yopo5"};